<h5>{{ data.titre }}</h5>
<div class="col-md-12">
  <mat-divider></mat-divider>
</div>
<div *ngIf="bpLineForm">
  <form focusInvalidInput class="row" [formGroup]="bpLineForm" (ngSubmit)="submit()" style="display: flex; justify-content: space-between;">
    <h6>Article</h6>
    <div class="col-md-12 data-class" > 
      <div class="d-flex">
        <mat-form-field class="full-width">
          <mat-label>Désignation</mat-label>
          <input matInput type="text" name="nth-ref-pu" placeholder="Désignation"
            formControlName="libelle" required>
            <mat-error>
              Veuillez sélectionner une désignation
            </mat-error>
        </mat-form-field>
      </div>
      <div class="d-flex">
        <mat-form-field class="flex-grow-2 mr-4">
          <mat-label>Qte</mat-label>
          <input matInput type="number" maxlength="30" name="nth-ref-qte" placeholder="QTE"
            matTooltip="La quantité ne peut pas être vide" matTooltipClass="error-tooltip" required
            formControlName="qte">
          <ng-template #qteOk>
            <input matInput type="number" maxlength="30" name="nth-ref-qte" placeholder="QTE  "
              required formControlName="qte">
          </ng-template>
          <mat-error>
            Veuillez sélectionner une quantité positive et non nulle
          </mat-error>
        </mat-form-field>

        <mat-form-field class="flex-grow-2 mr-4">
          <mat-label>Qte restante</mat-label>
          <input matInput type="number" [value]="bpLineForm.get('bcLigne').value ? bpLineForm.get('bcLigne').value.qteRestant : 0"
          disabled>
        </mat-form-field>
    
        <mat-form-field class="flex-grow-2 mr-4">
          <mat-label>PU</mat-label>
          <input matInput type="number" maxlength="30" name="nth-ref-pu" placeholder="PU  " required
            formControlName="pu"  step="0.01" lang="fr">
          <mat-icon matSuffix>euro_symbol
          </mat-icon>
          <mat-error>
            Veuillez saisir un prix unitaire
          </mat-error>
        </mat-form-field>
    
        <mat-form-field class="flex-grow-1 mr-4">
          <mat-label>HT</mat-label>
          <input matInput type="number" placeholder="HT"
            formControlName="ht" lang="fr">
          <mat-icon matSuffix >euro_symbol
          </mat-icon>
        </mat-form-field>
      
        <app-tva-field-autocomplete class="flex-grow-2 mr-4" [parentForm]="bpLineForm" libelle="TVA"
          codeControlName="codeTva" libelleControlName="libelleTva"
          tauxControlName="tauxTva" placeholder="TVA" [objets]="this.referentiel.tvas">
        </app-tva-field-autocomplete>
  
        <mat-form-field class="flex-grow-1">
          <mat-label>TTC</mat-label>
          <input matInput type="number" placeholder="TTC"
            formControlName="ttc" lang="fr">
          <mat-icon matSuffix >euro_symbol
          </mat-icon>
        </mat-form-field>
      
      </div>
    </div>

    <h6>Éléments financiers</h6>
    <div class="col-md-12 data-class">
      <div class="d-flex">
        <app-autocomplete-with-code-libelle-form class="flex-grow-1 mr-4" [parent]="bpLineForm" libelle="CA1"
          codeControlName="codeCa1" libelleControlName="libelleCa1"
          placeholder="CA1" [objets]="this.referentiel.ca1s">
        </app-autocomplete-with-code-libelle-form>

        <app-autocomplete-with-code-libelle-form class="flex-grow-1 mr-4" [parent]="bpLineForm" libelle="NA" 
          codeControlName="codeNa" libelleControlName="libelleNa"
          placeholder="NA" [objets]="this.referentiel.nas">
        </app-autocomplete-with-code-libelle-form>

        <app-autocomplete-with-code-libelle-form class="flex-grow-1" [parent]="bpLineForm" libelle="CG Charge"
          codeControlName="codeCgCharge" libelleControlName="libelleCgCharge"
          placeholder="CG" [objets]="[]">
        </app-autocomplete-with-code-libelle-form>
      </div>

      <div class="d-flex">
        <app-autocomplete-with-code-libelle-form class="flex-grow-1 mr-4" [parent]="bpLineForm" libelle="CA2"
          codeControlName="codeCa2" libelleControlName="libelleCa2"
          placeholder="CA2" [objets]="this.referentiel.ca2s">
        </app-autocomplete-with-code-libelle-form>

        <app-autocomplete-with-code-libelle-form class="flex-grow-1 mr-4" [parent]="bpLineForm" libelle="Complément"
          codeControlName="codeComp" libelleControlName="libelleComp"
          placeholder="Complément" [objets]="this.referentiel.comps">
        </app-autocomplete-with-code-libelle-form>

      </div>
    </div>
  
    <div class="container">
      <h6>Autres</h6>
      <div class="d-flex data-class px-3">
        <mat-form-field class="flex-grow-1 mr-4">
          <mat-label>Chantier</mat-label>
          <input matInput name="nth-ref-libelle" maxlength="10" placeholder="Chantier"
            formControlName="chantier">
        </mat-form-field>

        <mat-form-field class="flex-grow-1">
          <mat-label>Equipement</mat-label>
          <input matInput name="nth-ref-libelle" maxlength="12" placeholder="Equipement  "
            formControlName="vehicule">
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class=" col-md-6" style="margin-top: 40px;">
        <button mat-raised-button color="default" type="button" (click)="cancel()">Annuler</button>
      </div>
      <div class=" col-md-6" style="margin-top: 40px;">
        <button mat-raised-button color="primary" type="submit" class="raise" >Confirmer</button>
      </div>
    </div>
  </form>
</div>